import "./AboutCards.scss";
import React from 'react';
import { FaArrowRight } from 'react-icons/fa';
import { getImageUrl } from '../../utils/imageAssets';


const AboutCards = () => {
return (
    <div className="AboutCards">
        <section className="section section-alt">
        <div className="container">
            <div className="section-head">
            <h2 className="section-title">지온나래는 어떤 단체인가요?</h2>
            <p className="section-desc">
                지온나래는 GIST의 공식 학생 홍보대사로서, GIST의 우수성과 매력을 널리 알리는 역할을 수행하고 있습니다.
            </p>
            </div>

            <div className="grid">
            <a className="card" href="/tour">
                <div className="card-media">
                <img src={getImageUrl('/images/home/05.jpg')} alt="캠퍼스 투어" loading="lazy" decoding="async" />
                <div className="card-gradient" />
                <div className="card-title">캠퍼스 투어</div>
                </div>
                <div className="card-body">
                <p className="card-desc">방문객과 수험생을 위해 GIST의 주요 시설과 문화를 안내해요.</p>
                <div className="card-cta">자세히 보기 <FaArrowRight /></div>
                </div>
            </a>

            <a className="card" href="/guide">
                <div className="card-media">
                <img src={getImageUrl('/images/home/01.jpg')} alt="홍보 콘텐츠" loading="lazy" decoding="async" />
                <div className="card-gradient" />
                <div className="card-title">홍보 콘텐츠</div>
                </div>
                <div className="card-body">
                <p className="card-desc">다양한 미디어 콘텐츠로 학교 생활과 프로그램을 더 쉽게 전달해요.</p>
                <div className="card-cta">콘텐츠 보러가기 <FaArrowRight /></div>
                </div>
            </a>

            <a className="card" href="/guide">
                <div className="card-media">
                <img src={getImageUrl('/images/home/02.jpg')} alt="새내기 지원" loading="lazy" decoding="async" />
                <div className="card-gradient" />
                <div className="card-title">새내기 지원</div>
                </div>
                <div className="card-body">
                <p className="card-desc">신입생 캠프/가이드로 새내기의 적응을 돕습니다.</p>
                <div className="card-cta">가이드 보기 <FaArrowRight /></div>
                </div>
            </a>
            </div>

            <div className="center">
            <a className="btn primary" href="/about">
                지온나래 더 알아보기
            </a>
            </div>
        </div>
        </section>
    </div>
);
};

export default AboutCards;
